export { default as BaseDivider } from './BaseDivider';
